export const STATUS_META = {
  a_appeler: { label: "À appeler", short: "À appeler", cls: "bg-white text-brand-ink border-brand-line", dot: "bg-brand-subtle" },
  pas_repondu: { label: "Pas répondu", short: "NR", cls: "bg-white text-brand-subtle border-brand-line", dot: "bg-brand-subtle/60" },
  message_vocal: { label: "Message vocal", short: "Vocal", cls: "bg-brand-paper text-brand-subtle border-brand-line", dot: "bg-brand-subtle/70" },
  appele: { label: "Appelé", short: "Appelé", cls: "bg-brand-mossSoft text-brand-moss border-brand-moss/20", dot: "bg-brand-moss/40" },
  rappel: { label: "Rappel", short: "Rappel", cls: "bg-[#FAF8F1] text-[#6B5B33] border-[#E9E2CF]", dot: "bg-[#B79A4B]" },
  interesse: { label: "Intéressé", short: "Intéressé", cls: "bg-brand-moss/10 text-brand-moss border-brand-moss/25", dot: "bg-brand-moss/70" },
  rdv_pris: { label: "RDV pris", short: "RDV", cls: "bg-brand-moss text-white border-brand-moss", dot: "bg-brand-moss" },
  pas_interesse: { label: "Pas intéressé", short: "KO", cls: "bg-[#F8F3F0] text-[#7A4B3A] border-[#E9DED8]", dot: "bg-[#A9705C]" },
  mauvais_numero: { label: "Mauvais numéro", short: "Mauvais n°", cls: "bg-[#F8F3F0] text-[#7A4B3A] border-[#E9DED8]", dot: "bg-[#8C6A5F]" },
};

export const PIPELINE_COLUMNS = [
  { id: "a_appeler", label: "À appeler", statuses: ["a_appeler"] },
  { id: "appele", label: "Appelé", statuses: ["appele", "pas_repondu", "message_vocal"] },
  { id: "rappel", label: "Rappel", statuses: ["rappel"] },
  { id: "interesse", label: "Intéressé", statuses: ["interesse"] },
  { id: "rdv_pris", label: "RDV pris", statuses: ["rdv_pris"] },
  { id: "perdu", label: "Perdu", statuses: ["pas_interesse", "mauvais_numero"] },
];

// Boutons du compte rendu d'appel (ordre de la maquette)
export const CALL_OUTCOMES = [
  { status: "pas_repondu", label: "Pas répondu" },
  { status: "message_vocal", label: "Message vocal" },
  { status: "rappel", label: "Rappel", opens: "rappel" },
  { status: "interesse", label: "Intéressé" },
  { status: "rdv_pris", label: "RDV", opens: "rdv", primary: true },
  { status: "pas_interesse", label: "Pas intéressé" },
  { status: "mauvais_numero", label: "Mauvais numéro" },
  { status: "appele", label: "Note simple" },
];

export function statusMeta(status) {
  return STATUS_META[status] || STATUS_META.a_appeler;
}

// Rappel / RDV dont l'échéance est dépassée
export function isOverdue(dateStr) {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return false;
  return d.getTime() < Date.now();
}

export const OVERDUE_CLS = "bg-[#FBF2EE] text-[#8A3F27] border-[#EBD5CB]";
